module.exports = __webpack_public_path__ + "static/media/pdf.2e3ed000.svg";